import { c as _c } from "react/compiler-runtime";
import { ChampIcon } from './ChampionIcon';
import { twoXKO_metablob_v1 } from '../../../convex/metablobs/2xko/v1';
import { FuseIcon } from './FuseIcon';
export const TwoKOActivityFace = t0 => {
  const $ = _c(34);
  const {
    metablob: twoXKO,
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? 96 : t1;
  const variant = t2 === undefined ? "normal" : t2;
  if (!twoXKO) {
    return null;
  }
  if (variant === "slim") {
    let t3;
    if ($[0] !== size || $[1] !== twoXKO) {
      t3 = twoXKO?.pointChampion && <ChampIcon championName={twoXKO.pointChampion} size={size} />;
      $[0] = size;
      $[1] = twoXKO;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== size || $[4] !== twoXKO) {
      t4 = twoXKO?.assistChampion && <ChampIcon championName={twoXKO.assistChampion} size={size} />;
      $[3] = size;
      $[4] = twoXKO;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
      t5 = <div className="flex flex-row gap-1">{t3}{t4}</div>;
      $[6] = t3;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== size || $[10] !== twoXKO) {
      t6 = twoXKO?.fuse && <FuseIcon fuse={twoXKO.fuse} size={size * 0.7} />;
      $[9] = size;
      $[10] = twoXKO;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t6) {
      t7 = <div>{t6}</div>;
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t5 || $[15] !== t7) {
      t8 = <div className="flex flex-row gap-2 items-center">{t5}{t7}</div>;
      $[14] = t5;
      $[15] = t7;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    return t8;
  }
  let t3;
  if ($[17] !== size || $[18] !== twoXKO) {
    t3 = twoXKO?.pointChampion && <ChampIcon championName={twoXKO.pointChampion} size={size} />;
    $[17] = size;
    $[18] = twoXKO;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== size || $[21] !== twoXKO) {
    t4 = twoXKO?.assistChampion && <ChampIcon championName={twoXKO.assistChampion} size={size} />;
    $[20] = size;
    $[21] = twoXKO;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== t3 || $[24] !== t4) {
    t5 = <div className="flex flex-row gap-1">{t3}{t4}</div>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== size || $[27] !== twoXKO) {
    t6 = twoXKO?.fuse && <FuseIcon fuse={twoXKO.fuse} size={size * 0.7} />;
    $[26] = size;
    $[27] = twoXKO;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== t6) {
    t7 = <div>{t6}</div>;
    $[29] = t6;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== t5 || $[32] !== t7) {
    t8 = <>{t5}{t7}</>;
    $[31] = t5;
    $[32] = t7;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  return t8;
};